module.exports = __webpack_public_path__ + "react/fonts/radio.fdf43ab8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/radio.svg
// module id = 1211
// module chunks = 0